import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      d: "M4.5 15.409h3.364V19.5H4.5zm7.273 0h3.364V19.5h-3.364zm-3.637-2.182H11.5V19.5H8.136zm7.273-2.909h3.364V19.5h-3.364zM4 10.546l5.727-4 3.055 2.181L19.272 4"
    }, null, -1)
  ])]);
}
const m = { render: l };
export {
  m as default,
  l as render
};
